import React from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../../../packages/IconButton";
import { DeleteIcon, EditIcon } from "../../../packages/SVGs";

const ChemicalActionBtnRenderer = ({ data, node, context }) => {
  const { t } = useTranslation();
  const canDeleteChemical = data?.is_custom;

  const handleBtnClick = (eventOrPayload) => {
    eventOrPayload?.preventDefault?.();
    eventOrPayload?.stopPropagation?.();

    const target = eventOrPayload?.target;
    const name = target?.name || target?.closest?.("button")?.name;

    if (!name) {
      return;
    }

    if (context.onActionBtnClick) {
      const latestChemicalData = node?.data || data;
      context.onActionBtnClick({
        actionType: name,
        chemicalData: latestChemicalData,
      });
    }
  };

  return (
    <div className="d-flex">
      <IconButton
        id={`edit_chemical_${data.id}_btn`}
        name="edit-chemical-btn"
        tooltip={t("ValueStrings.edit")}
        aria-label="edit"
        onMouseDown={(event) => event.stopPropagation()}
        onClick={handleBtnClick}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        id={`delete_chemical_${data.id}_btn`}
        name="delete-chemical-btn"
        disabled={!canDeleteChemical}
        tooltip={t("ValueStrings.delete")}
        aria-label="delete"
        onMouseDown={(event) => event.stopPropagation()}
        onClick={handleBtnClick}
      >
        <DeleteIcon disabled={!canDeleteChemical} />
      </IconButton>
    </div>
  );
};

export default ChemicalActionBtnRenderer;
